var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCenterAlignText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 7.3125C4.5 6.96732 4.77982 6.6875 5.125 6.6875H18.875C19.2202 6.6875 19.5 6.96732 19.5 7.3125C19.5 7.65768 19.2202 7.9375 18.875 7.9375H5.125C4.77982 7.9375 4.5 7.65768 4.5 7.3125Z",
    fill: "#1A181E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.375 10.4375C6.375 10.0923 6.65482 9.8125 7 9.8125H17C17.3452 9.8125 17.625 10.0923 17.625 10.4375C17.625 10.7827 17.3452 11.0625 17 11.0625H7C6.65482 11.0625 6.375 10.7827 6.375 10.4375Z",
    fill: "#1A181E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 13.5625C4.5 13.2173 4.77982 12.9375 5.125 12.9375H18.875C19.2202 12.9375 19.5 13.2173 19.5 13.5625C19.5 13.9077 19.2202 14.1875 18.875 14.1875H5.125C4.77982 14.1875 4.5 13.9077 4.5 13.5625Z",
    fill: "#1A181E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.375 16.6875C6.375 16.3423 6.65482 16.0625 7 16.0625H17C17.3452 16.0625 17.625 16.3423 17.625 16.6875C17.625 17.0327 17.3452 17.3125 17 17.3125H7C6.65482 17.3125 6.375 17.0327 6.375 16.6875Z",
    fill: "#1A181E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterAlignText);
export default __webpack_public_path__ + "static/media/center-align-text.a0ba2e7bfb2740aceac5571c22cf44ee.svg";
export { ForwardRef as ReactComponent };